@if (loading()) {
  <div class="lds-facebook">
    <div></div>
    <div></div>
    <div></div>
  </div>
} @else {
  @if (!regSuccessful) {
    <div class="site-container-1000 mt-8 reg-containers">
      <div class="w-full">
        <div class="w-full text-center">
          <h1>Create an Account</h1>
          <p>Create an partner account and get access to your state training report information.</p>
        </div>
      </div>

      <form [formGroup]="form" class="mt-8 flex flex-col h-full justify-between">
        <div>
          <div class="w-full flex lg:gap-6">
            <div class="w-full">
              <h2 class="learner">Partner Account Admin Information</h2>
            </div>
          </div>

          <div class="w-full flex lg:gap-6">
            <div class="w-full lg:w-1/2">
              <mat-form-field class="w-full">
                <mat-label>First Name</mat-label>
                <input matInput type="text" formControlName="firstName" />
                @if (form.controls['firstName'].hasError('required') && form.controls['firstName'].touched) {
                  <mat-error>Required </mat-error>
                }
                @if (form.controls['firstName'].errors?.['firstName'] && form.controls['firstName'].touched) {
                  <mat-error>You must include a valid Full Name. </mat-error>
                }
                @if (form.controls['firstName'].errors?.['message']) {
                  <mat-error>{{ form.controls['firstName'].getError('message') }}</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="w-full lg:w-1/2">
              <mat-form-field class="w-full">
                <mat-label>Last Name</mat-label>
                <input matInput type="text" formControlName="lastName" />
                @if (form.controls['lastName'].hasError('required') && form.controls['lastName'].touched) {
                  <mat-error>Required </mat-error>
                }
                @if (form.controls['lastName'].errors?.['lastName'] && form.controls['lastName'].touched) {
                  <mat-error>You must include a valid Last Name. </mat-error>
                }
                @if (form.controls['lastName'].errors?.['message']) {
                  <mat-error>{{ form.controls['lastName'].getError('message') }}</mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <div class="w-full flex lg:gap-6 mt-4">
            <div class="w-full">
              <mat-form-field class="w-full">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  type="text"
                  (blur)="checkEmail($event, form.controls['email'])"
                  formControlName="email"
                />
                @if (form.controls['email'].hasError('required') && form.controls['email'].touched) {
                  <mat-error>Required </mat-error>
                }
                @if (form.controls['email'].errors?.['email'] && form.controls['email'].touched) {
                  <mat-error>You must include a valid email. </mat-error>
                }
              </mat-form-field>
              <div [ngClass]="{ 'mb-1 -mt-4 ': form.controls['email'].errors?.['message'] }">
                @if (form.controls['email'].errors?.['message']) {
                  <mat-error class="text-danger support-text">{{
                    form.controls['email'].getError('message')
                  }}</mat-error>
                }
              </div>
            </div>
          </div>

          <div class="w-full flex lg:gap-6 mt-4">
            <div class="w-full lg:w-1/2">
              <mat-form-field class="w-full">
                <mat-label>Password</mat-label>
                <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
                <mat-icon matSuffix class="cursor-default eye-hidden" (click)="hide = !hide">{{
                  hide ? 'visibility' : 'visibility_off'
                }}</mat-icon>
                @if (form.controls['password'].hasError('required') && form.controls['password'].touched) {
                  <mat-error>Required </mat-error>
                }
                @if (form.controls['password'].errors?.['password'] && form.controls['password'].touched) {
                  <mat-error>You must include a valid password. </mat-error>
                }
              </mat-form-field>
              <div [ngClass]="{ 'mb-1 -mt-4 ': form.controls['password'].errors?.['message'] }">
                @if (form.controls['password'].errors?.['message']) {
                  <mat-error>{{ form.controls['password'].getError('message') }}</mat-error>
                }
              </div>
            </div>
            <div class="w-full lg:w-1/2">
              <mat-form-field class="w-full">
                <mat-label>Confirm Password</mat-label>
                <input
                  matInput
                  [type]="chide ? 'password' : 'text'"
                  formControlName="confirmPassword"
                  appBlockCopyPaste
                />
                <mat-icon matSuffix class="cursor-default eye-hidden" (click)="chide = !chide">{{
                  chide ? 'visibility' : 'visibility_off'
                }}</mat-icon>
                @if (
                  form.controls['confirmPassword'].hasError('required') && form.controls['confirmPassword'].touched
                ) {
                  <mat-error>You must include confirm password. </mat-error>
                }
                @if (
                  form.controls['confirmPassword'].errors?.['notEquivalent'] && form.controls['confirmPassword'].touched
                ) {
                  <mat-error>Passwords do not match. </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="w-full">
          <div class="text-center mt-5">
            <button
              type="submit"
              class="btn-primary large"
              [disabled]="disabled()"
              id="CreateAccountIndividual"
              (click)="registerUser()"
            >
              Create a Partner Account
            </button>
          </div>

          <div class="mt-3">
            <div class="flex flex-wrap text-primary justify-center">
              <p class="large">
                <span class="mr-1">By signing up, you accept our</span>
                <a
                  href="https://mandatedreportertraining.com/company/terms-of-use"
                  target="_blank"
                  class="primary-link mr-1"
                  >Terms Of Use</a
                >
                <span class="mr-1">and</span>
                <a
                  href="https://mandatedreportertraining.com/company/privacy-statement"
                  target="_blank"
                  class="primary-link"
                  >Privacy Statement</a
                >
              </p>
            </div>
            <div class="flex text-primary justify-center">
              <p class="large">
                <span class="mr-1">Already have an account?</span>
                <a href="/login" class="primary-link">Log In.</a>
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  } @else {
    <!-- <div class="site-container-1000 mt-8">
  <div class="w-full">
    <div class="w-full text-center">
      <h1>Create an Account</h1>
      <p>
        Create an partner account and get access to your state training report information.
      </p>
    </div>
  </div>
</div>

<h2>Setup Two Factor Authentication</h2>
<div id="qrCode" class="w-[200px]"></div>
<form [formGroup]="otpForm">
  <mat-form-field>
    <mat-label>Authenticator Code</mat-label>
    <input matInput type="text" formControlName="verificationCode" mask="000-000" />
    <mat-error *ngIf="otpForm.controls['verificationCode'].errors?.['wrong'] && otpForm.controls['verificationCode'].touched">
      That code didn't work
    </mat-error>
  </mat-form-field>
  <button type="submit" (click)="onSubmit2fa()" [disabled]="disabled()" class="btn btn-primary mb-10 mt-10">
    Verify
  </button>
</form> -->
  }
}
